import { STATUSES, makePaginationState } from 'app/utils/redux';

import * as t from './types';


const initialState = {
  paymentHistories: makePaginationState(),
};


export default (state = initialState, action) => {
  switch (action.type) {
    // fetch coin histories
    case `${t.FETCH_PAYMENT_HISTORIES}_PENDING`:
      return {
        ...state,
        paymentHistories: {
          ...state.paymentHistories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_PAYMENT_HISTORIES}_SUCCESS`:
      return {
        ...state,
        paymentHistories: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.paymentHistories.pagination.items
              .concat(action.payload.result.items),
          },
        },
      };
    case `${t.FETCH_PAYMENT_HISTORIES}_ERROR`:
      return {
        ...state,
        paymentHistories: {
          ...state.paymentHistories,
          status: STATUSES.ERROR,
          isLoaded: true,
        },
      };

    // reset
    case t.RESET:
      return {
        paymentHistories: makePaginationState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/paymentHistory/reducer.js